import React from'react';
import PropTypes from'prop-types';
import'./EventStatus.css';

var EventStatus=function EventStatus(_ref){var statusText=_ref.statusText,toolTipText=_ref.toolTipText;return(
React.createElement('div',{className:'event-status '+statusText.toLowerCase()},
toolTipText&&
React.createElement('span',{className:'event-status-tooltip'},toolTipText)));};




EventStatus.propTypes={
statusText:PropTypes.string.isRequired,
toolTipText:PropTypes.string};


EventStatus.defaultProps={
toolTipText:''};


export default EventStatus;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0V2ZW50U3RhdHVzL0V2ZW50U3RhdHVzLmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIlByb3BUeXBlcyIsIkV2ZW50U3RhdHVzIiwic3RhdHVzVGV4dCIsInRvb2xUaXBUZXh0IiwidG9Mb3dlckNhc2UiLCJwcm9wVHlwZXMiLCJzdHJpbmciLCJpc1JlcXVpcmVkIiwiZGVmYXVsdFByb3BzIl0sIm1hcHBpbmdzIjoiQUFBQSxNQUFPQSxNQUFQLEtBQWtCLE9BQWxCO0FBQ0EsTUFBT0MsVUFBUCxLQUFzQixZQUF0QjtBQUNBLE1BQU8sbUJBQVA7O0FBRUEsR0FBTUMsYUFBYyxRQUFkQSxZQUFjLFVBQUdDLFdBQUgsTUFBR0EsVUFBSCxDQUFlQyxXQUFmLE1BQWVBLFdBQWY7QUFDbEIsMkJBQUssMEJBQTJCRCxXQUFXRSxXQUFYLEVBQWhDO0FBQ0lEO0FBQ0EsNEJBQU0sVUFBVSxzQkFBaEIsRUFBd0NBLFdBQXhDLENBRkosQ0FEa0IsR0FBcEI7Ozs7O0FBUUFGLFlBQVlJLFNBQVosQ0FBd0I7QUFDdEJILFdBQVlGLFVBQVVNLE1BQVYsQ0FBaUJDLFVBRFA7QUFFdEJKLFlBQWFILFVBQVVNLE1BRkQsQ0FBeEI7OztBQUtBTCxZQUFZTyxZQUFaLENBQTJCO0FBQ3pCTCxZQUFhLEVBRFksQ0FBM0I7OztBQUlBLGNBQWVGLFlBQWYiLCJmaWxlIjoiRXZlbnRTdGF0dXMuanN4Iiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCAnLi9FdmVudFN0YXR1cy5jc3MnO1xuXG5jb25zdCBFdmVudFN0YXR1cyA9ICh7IHN0YXR1c1RleHQsIHRvb2xUaXBUZXh0IH0pID0+IChcbiAgPGRpdiBjbGFzc05hbWU9e2BldmVudC1zdGF0dXMgJHtzdGF0dXNUZXh0LnRvTG93ZXJDYXNlKCl9YH0+XG4gICAgeyB0b29sVGlwVGV4dCAmJlxuICAgICAgPHNwYW4gY2xhc3NOYW1lPVwiZXZlbnQtc3RhdHVzLXRvb2x0aXBcIj57dG9vbFRpcFRleHR9PC9zcGFuPlxuICAgIH1cbiAgPC9kaXY+XG4pO1xuXG5FdmVudFN0YXR1cy5wcm9wVHlwZXMgPSB7XG4gIHN0YXR1c1RleHQ6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdG9vbFRpcFRleHQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5FdmVudFN0YXR1cy5kZWZhdWx0UHJvcHMgPSB7XG4gIHRvb2xUaXBUZXh0OiAnJyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEV2ZW50U3RhdHVzO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/components/EventStatus/EventStatus.jsx
// module id = 2169
// module chunks = 0